import { NumberValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, serializeSchemaValidationError, validatePayload, validatePayloadAndThrow, } from '../../../../utils/validate-payload.js';
import { validateCategoryFacetValue } from '../../../facets/category-facet-set/category-facet-validate-payload.js';
export const updateCategoryFacetNumberOfValues = createAction('commerce/facets/categoryFacet/updateNumberOfValues', (payload) => validatePayload(payload, {
    facetId: requiredNonEmptyString,
    numberOfValues: new NumberValue({ required: false, min: 1 }),
}));
export const toggleSelectCategoryFacetValue = createAction('commerce/facets/categoryFacet/toggleSelectValue', (payload) => {
    try {
        validatePayloadAndThrow(payload.facetId, requiredNonEmptyString);
        validateCategoryFacetValue(payload.selection);
        return { payload, error: null };
    }
    catch (error) {
        return { payload, error: serializeSchemaValidationError(error) };
    }
});
